import React from 'react';
import i18n from '@shared/i18n';
import { useBuyerProductStore } from 'app/store/product';
import { type BuyerLayoutProps } from 'shop-ui/types';
import STYLE from './ProductInfoGroup.module.scss';

interface ProductHeadingProps extends BuyerLayoutProps {}

export const ProductHeading: React.FC<ProductHeadingProps> = (props) => {
    const { isBuyer } = props;

    const { product } = useBuyerProductStore();

    const headingContent = isBuyer
        ? product?.name || ''
        : i18n.gettext('這裡會顯示商品標題');

    return (
        <div className={STYLE.heading}>
            <h1>{headingContent}</h1>
        </div>
    );
};
